'use strict';

angular
    .module('App.v1', [
        'App.v1.Controllers',
        'App.v1.Controllers.Design',
        'App.v1.Controllers.Public',
        'App.v1.Services',
        'App.v1.Directives',
        'App.v1.Filters',
        'ngResource'])

    .config(['$locationProvider',
        function ($locationProvider) {
            $locationProvider.html5Mode(true).hashPrefix('!');
        }]);

// Initialize AlertAudio service early (no-op on public pages if service doesn't exist)
angular.module('App.v1')
    .run(['App.v1.Services.AlertAudio', function (alertAudio) {
        if (alertAudio && typeof alertAudio.init === 'function') {
            alertAudio.init();
        }
    }]);

// Register Services module. Will add specific services to the module via files in ./Services/*.js files
angular.module('App.v1.Services', ['ngResource']);

// Register Controllers module. Will add specific services to the module via files in ./Controllers/*.js files
angular.module('App.v1.Controllers', ['App.v1.Services', 'ngAnimate']);

// Register Design Controllers module with file upload capabilities (for Design controllers only)
angular.module('App.v1.Controllers.Design', ['App.v1.Controllers', 'ngFileUpload']);

//Register Public Controllers module that are very slim and don't need the full services
angular.module('App.v1.Controllers.Public', ['App.v1.Services']);

//// Register Directives module. Will add specific services to the module via files in ./Directives/*.js files
angular.module('App.v1.Directives', ['ngMessages']);

angular.module('App.v1.Filters', []);